import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SIDEBAR_TOGGLE_DIRECTIVES } from './../share/sidebar.directive';
import { NAV_DROPDOWN_DIRECTIVES } from './../share/nav-dropdown.directive';

import { BsDropdownModule } from 'ng2-bootstrap/dropdown';
import { TabsModule } from 'ng2-bootstrap/tabs';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { SharingComponent } from './sharing/sharing.component';
import { LoaderComponent } from './loader/loader.component'
import { FormsModule , ReactiveFormsModule} from '@angular/forms';

import { Angular2FontawesomeModule } from 'angular2-fontawesome/angular2-fontawesome';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown/angular2-multiselect-dropdown';
import { MyDatePickerModule } from 'mydatepicker';
import { MyDateRangePickerModule } from 'mydaterangepicker';
// import { SplitPaneModule } from 'ng2-split-pane/lib/ng2-split-pane';
// import { SplitModule } from 'ng2-split'
import { DragulaModule, DragulaService } from 'ng2-dragula/ng2-dragula';
import { Ng2DragDropModule } from 'ng2-drag-drop';
import { ImageUploadModule } from "angular2-image-upload";
import { UiSwitchModule } from 'ngx-toggle-switch/src';
import { FancyImageUploaderModule  } from 'ng2-fancy-image-uploader';
import { GetItemService } from '../get-item.service';
import { TagInputModule } from 'ngx-chips';
import { AngularSplitModule } from 'angular-split';

//cookie service
import { CookieService } from 'ngx-cookie-service';

//auth service
import { AuthServiceService } from '../auth-service.service';
import { ChartsModule } from 'ng2-charts';
import 'chart.piecelabel.js'; // after 'ng2-charts'
// import { ChartModule } from 'angular-highcharts';
import { DeviceDetectorModule } from 'ngx-device-detector';

@NgModule({
  imports: [
    CommonModule,
    BsDropdownModule.forRoot(),
    TabsModule.forRoot(),
    TooltipModule.forRoot(),
    FormsModule , ReactiveFormsModule,
    ChartsModule,
    Angular2FontawesomeModule,
    AngularMultiSelectModule,
    MyDatePickerModule,
    MyDateRangePickerModule,
    // ChartModule,
    //  SplitPaneModule,
    //  SplitModule,
     DragulaModule,
     Ng2DragDropModule.forRoot(),
     ImageUploadModule.forRoot(),
     UiSwitchModule,
     FancyImageUploaderModule ,
     TagInputModule,
     AngularSplitModule,
     DeviceDetectorModule.forRoot()

  ],
  declarations: [
    NAV_DROPDOWN_DIRECTIVES,
    SIDEBAR_TOGGLE_DIRECTIVES,
    SharingComponent,
    LoaderComponent
  ],
   exports: [
    NAV_DROPDOWN_DIRECTIVES,
    SIDEBAR_TOGGLE_DIRECTIVES,
    SharingComponent,
    LoaderComponent,
    TooltipModule,
    Angular2FontawesomeModule,
    AngularMultiSelectModule,
    MyDatePickerModule,
    MyDateRangePickerModule,
    //  SplitPaneModule,
    //  SplitModule,
     DragulaModule,
     Ng2DragDropModule,
     ImageUploadModule,
     UiSwitchModule,
     FancyImageUploaderModule ,
     TagInputModule,
     AngularSplitModule
     
  ],
  providers:[GetItemService,CookieService,AuthServiceService]
})
export class ShareModule { }



// WEBPACK FOOTER //
// ./src/app/share/share.module.ts